module.exports = __webpack_public_path__ + "static/media/Bigfoot2.8491256e.jpg";